import { useMemo } from 'react';

import { isDealsFeatureEnabled, type IDealsWidgetsConfig } from '../../../utils/dealsExperiment';
import type { IDealsBannerProps } from '../../../components/DealsBanner';
import type { IDealsLeadFormBlockProps } from '../../../components/DealsLeadForm';

export interface IDealsExperimentWidgets {
  dealsLeadForm: IDealsLeadFormBlockProps;
  dealsBanner?: IDealsBannerProps;
}

/**
 * Собирает пропсы формы и баннера из фасада RS-конфигов.
 * Баннер берёт заголовки модалки из текстов формы, а не из уже собранных пропсов.
 * Группа A/B здесь не учитывается — её проверяет useDealsExperiment.
 */
export const useDealsWidgetsProps = (
  postId: number,
  isFeatureEnabled: boolean | undefined,
  regionOptions: IDealsLeadFormBlockProps['regionOptions'],
  { form, banner }: IDealsWidgetsConfig,
): IDealsExperimentWidgets | undefined => {
  return useMemo(() => {
    if (!isDealsFeatureEnabled(isFeatureEnabled) || !form) {
      return undefined;
    }

    const dealsLeadForm: IDealsLeadFormBlockProps = {
      leadIn: form.formLeadIn,
      title: form.formTitle,
      subtitle: form.formSubtitle,
      regionOptions,
    };

    if (!banner) {
      return { dealsLeadForm };
    }

    const dealsBanner: IDealsBannerProps = {
      title: banner.title,
      formTitle: form.formTitle,
      formSubtitle: form.formSubtitle,
      regionOptions,
      postId,
    };

    return { dealsLeadForm, dealsBanner };
  }, [banner, form, isFeatureEnabled, postId, regionOptions]);
};
